import React from 'react'
import ReactDOM from 'react-dom/client'
import './polyfills'
import './index.css'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import { AuthProvider } from './context/AuthContext'

const root = ReactDOM.createRoot(document.getElementById('root'))
// Outermost boundary: a crash in App or AuthContext used to leave a white
// screen with no explanation. Wraps the provider too, since auth is where a
// bad session shape would throw.
root.render(
  <ErrorBoundary fullScreen title="The app could not start">
    <AuthProvider>
      <App />
    </AuthProvider>
  </ErrorBoundary>
)
